/* global _LTracker */
import moment from 'moment';
import { AppStep } from '../reducers/navigation';
import * as API from '../utilities/api';
import { receiveSessionToken, expireSessionToken, resetDiscount, removePromoText, fetchCheckoutInfo } from './checkout';
import { fetchDates, clearSelectedDate } from './date';
import { fetchLocations, goDirect } from './bookingLocation';
import { fetchSequences, sequenceStepForward, sequenceStepBack, clearSelectedSequence } from './sequence';
import { fetchStations } from './station';
import { fetchPartyRooms } from './partyRoom';
import { stopLoad, startLoad } from './loading';
import { fetchDiscounts } from './discount';
import { goRouting, HOME, LOCATION, DATE, SEQUENCES, STATIONS, PARTYROOMS, CHECKOUT, PAY, isModal } from '../routesMap';
import { resetCart } from '.';
import { resetGiftCard } from './giftCard';
import { tryResetApp } from '../actions/index';

export const AWAIT_NAVIGATION = 'AWAIT_NAVIGATION';
export const CANCEL_NAVIGATION = 'CANCEL_NAVIGATION';
export const NAVIGATE_BACK = 'NAVIGATE_BACK';
export const NAVIGATE_TO = 'NAVIGATE_TO';
export function awaitNavigation() { return { type: AWAIT_NAVIGATION }; }
export function cancelNavigation() { return { type: CANCEL_NAVIGATION }; }
export function navigateBack() { return { type: NAVIGATE_BACK }; }

function performFetchWork(step, dispatch, getState) {
    const state = getState();
    return new Promise((resolve, reject) => {
        switch (step) {
            case AppStep.Location:
                dispatch(fetchLocations(true))
                    .then(resolve)
                    .catch(error => {
                        reject(error)
                    });
                break;
            case AppStep.Date:
                dispatch(fetchDates(true))
                .then(() => {
                    dispatch(fetchDiscounts(state.bookingLocation.selectedLocationId))
                    .then(resolve)
                    .catch(error => reject(error));
                })
                .catch(error => reject(error));
                break;
            case AppStep.Sequence:
                dispatch(fetchSequences(true))
                .then(resolve)
                .catch(error => reject(error));
                break;
            case AppStep.Station:
                dispatch(fetchStations(true))
                .then(resolve)
                .catch((error) => reject(error));
                break;
            case AppStep.PartyRoom:
                dispatch(fetchPartyRooms(true))
                .then(resolve)
                .catch((error) => reject(error));
                break;
            case AppStep.Checkout:
                dispatch(fetchCheckoutInfo())
                .then(resolve)
                .catch((error) => reject(error));
                break;
            case AppStep.Pay:
                API.holdItems(state)
                .then((sessionTokenResponse) => {
                    dispatch(receiveSessionToken(sessionTokenResponse.sessionToken, sessionTokenResponse.purchaseCode, sessionTokenResponse.signedAuthorizationRequest));
                    resolve();
                })
                .catch((error) => reject(error));
                break;
            default:
                return reject('invalid state for forward target work: ' + step);
        }
    });
}

function performTargetWork(step, dispatch, getState) {
  const state = getState();
  return new Promise((resolve, reject) => {
    switch (step) {
      case AppStep.Location:
        //check if usedBookingLocalStorage is still true (active) for automated functionality
        if (!state.bookingLocation.usedBookingLocalStorage) {
          dispatch(resetCart());
          if (state.date.done) dispatch(clearSelectedDate());
        }
        return resolve();
      case AppStep.Date:
        dispatch(resetCart());
        return resolve();
      case AppStep.Sequence:
        dispatch(clearSelectedSequence());
        return resolve();
      case AppStep.Station:
      case AppStep.PartyRoom:
      case AppStep.Checkout:
        isStillAvail(state)
          .then(() => {
            if (step === AppStep.Checkout) dispatch(expireSessionToken());
            // If we clicked on a sequence, change targetState to be correct
            if (state.sequence.inSequence) {
              const seq = state.sequence;
              let sequenceNeeded = null;
              try {
                sequenceNeeded = seq.selectedSequence.sequence_steps.find(sequence => {
                  return sequence.sequence_item_id === step;
                });
              } catch (error) {
                reject('Unable to find next sequence item: ' + error);
              };
              if (sequenceNeeded) {
                if (sequenceNeeded.index === seq.sequenceStep + 1) {
                  dispatch(sequenceStepForward());
                }
                else if (sequenceNeeded.index === seq.sequenceStep - 1) {
                  dispatch(sequenceStepBack());
                  dispatch(removePromoText());
                  dispatch(resetDiscount());
                  dispatch(resetGiftCard());
                }
                else if (sequenceNeeded.index !== seq.sequenceStep) {
                  reject('Invalid sequence step');
                }
              }
            }
            resolve();
          })
          .catch((error) => { reject(error); });
        break;
      case AppStep.Pay:
        // currently nothing special
        return resolve();
      default:
        return reject('Error: Unknown step to navigate to');
    }
  });
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const MAX_ATTEMPTS = 20;

async function waitNav(getState) {
  let curAttempts = 0;

  while(true) {
    const state = getState();

    if (state.navigation.navigating) {
      if(curAttempts < MAX_ATTEMPTS) {
        await sleep(100);
        curAttempts++;
        continue;
      } else {
        return false;
      }
    }
    return true;
  }
}

function errorHandler(dispatch, error, info) {
    console.error(error);

    _LTracker.push({ error, info });

    alert("An exception has occured and the app must be restarted.\nIf this issue persists, please contact Ctrl V.")
    dispatch(tryResetApp());
}

export function tryNavigateTo(step) {
  return (dispatch, getState) => {
    return new Promise(async (resolve, reject) => {
      let state = getState();

      // Make sure we aren't already navigating
      if (state.navigation.navigating) {
        if(!waitNav(getState)) {
          dispatch(cancelNavigation());
          reject('Cannot navigate, already navigating');
        }

        state = getState();
      }

        // Allow loading screen to show
        dispatch(startLoad());
        dispatch(awaitNavigation());

        try {
            await performTargetWork(step, dispatch, getState);
        } catch(error) {

            errorHandler(dispatch, error, {
                message: `Failure performing fetch work`,
                step: step,
            });

            return;
        }

        try {
            await performFetchWork(step, dispatch, getState);
        } catch(error) {

            errorHandler(dispatch, error, {
                message: `Failure performing fetch work`,
                step: step,
            });
            return;
        }

        try {

        const newState = getState();
        if (newState.navigation.navigating) {
          if (newState.bookingLocation.goDirect) {
            dispatch(goDirect(false));
            dispatch(cancelNavigation());
            if (!isModal) dispatch(goToRoute(AppStep.Date));
            else dispatch(tryNavigateTo(AppStep.Date));
          }
          else {
            dispatch(navigateTo(step));
            dispatch(stopLoad());
          }
          resolve();
        }
      } catch(error) {
        dispatch(cancelNavigation());
        dispatch(stopLoad());

        console.error(error);

        errorHandler(dispatch, error, {
            message: `Failure during dispatch`,
            step: step
        });
        return;
      }

    });
  };
}

// step: AppStep from '../reducers/navigation'
export function navigateTo(step) {
  return {
    type: NAVIGATE_TO,
    step
  };
}

export function tryNavigateSequence(forward) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      dispatch(startLoad());
      let targetState = 0;

      // figure out targetState
      try {
        // If we clicked on a sequence, change targetState to be correct
        if (state.sequence.inSequence) {
          const seq = state.sequence;
          const targetSequenceStep = forward ? seq.sequenceStep + 1 : seq.sequenceStep - 1;
          let sequenceNeeded = null;

          // go to the next sequence step
          try {
            sequenceNeeded = seq.selectedSequence.sequence_steps.find(sequence => {
              return sequence.index === targetSequenceStep;
            });
          } catch (error) {
            reject('Unable to find next sequence item: ' + error);
          };
          // if !targetState, we have hit the end of the sequence (without going back to SequenceSelection)
          //    therefore it is safe to assume we have just completed the checkout information and need to pay.
          if (sequenceNeeded) {
            targetState = sequenceNeeded.sequence_item_id;
            if (forward) dispatch(sequenceStepForward());
            else dispatch(sequenceStepBack());
          }
          else if (forward) targetState = AppStep.Pay;
          else targetState = AppStep.Sequence;

          dispatch(stopLoad());
          if (!isModal) dispatch(goToRoute(targetState));
          else dispatch(tryNavigateTo(targetState));
          resolve();
        } 
      }
      catch (error) {
        dispatch(stopLoad());
        console.error(error);
      }
    });
  }
}

// Checks if selected stations are still available (not in the past) to buy
function isStillAvail(state) {
  return new Promise((resolve, reject) => {
    const selPrs = Object.keys(state.partyRoom.selectedPartyRooms);
    const selStats = Object.keys(state.station.selectedStations);
    const selTimeslots = [...selStats, ...selPrs];
    for (let i = 0; i < selTimeslots.length; i++) {
      const selTimeslot = selTimeslots[i];
      if (selTimeslot) {
        const ts = state.station.stationsData;
        if (ts) {
          for (let j in ts.timeslots) {
            if (j && ts.timeslots[j] && ts.timeslots[j].utc_moment.valueOf() <= moment().valueOf() &&
              ts.timeslots[j].timeslotId.toString() === selTimeslot) {
              return reject('Timeslot is in the past.');
            }
          }
        }
        return resolve();
      }
    }
    return resolve();
  });
}

export function goToRoute(step) {
  switch (step) {
    case AppStep.Location:
      return goRouting(LOCATION);
    case AppStep.Date:
      return goRouting(DATE);
    case AppStep.Sequence:
      return goRouting(SEQUENCES);
    case AppStep.Station:
      return goRouting(STATIONS);
    case AppStep.PartyRoom:
      return goRouting(PARTYROOMS);
    case AppStep.Checkout:
      return goRouting(CHECKOUT);
    case AppStep.Pay:
      return goRouting(PAY);
    default:
      console.error('Cannot go to route: ' + step);
      return goRouting(HOME);
  }
}